export default __webpack_public_path__ + "static/media/afpWhite.4d2bf335.svg";